"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseIntersectionDef = void 0;
const parseDef_1 = require("../parseDef");
function parseIntersectionDef(def, refs) {
    const allOf = [
        (0, parseDef_1.parseDef)(def.left._def, refs.addToPath("allOf", "0")),
        (0, parseDef_1.parseDef)(def.right._def, refs.addToPath("allOf", "1")),
    ].filter((x) => !!x);
    return allOf.length ? { allOf } : undefined;
}
exports.parseIntersectionDef = parseIntersectionDef;
